import React from 'react';
import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from 'react-router-dom';
import Div from "@jumbo/shared/Div";
import { Link } from 'react-router-dom';


const Error404 = () => {

    const location = useLocation();

    return (
        <Div sx={{
            flex: 1,
            flexWrap: 'wrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: theme => theme.spacing(4),
        }}>
            <Div sx={{display: 'flex', justifyContent: 'center',mb: 3}}>
                <img src={"/images/undraw_page_not_found.svg"} alt="Not found" width="20%"/>
            </Div>
            <Typography align={"center"} component={"h2"} variant={"h1"} color={"text.secondary"} mb={3}>
                Oops, an error has occurred. Page not found!
            </Typography>
            {/* <FormControl fullWidth variant="outlined" sx={{maxWidth: 360, mb: 2}}>
                <OutlinedInput
                    id="outlined-search"
                    type="search"
                    placeholder="Search..."
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton aria-label="Search" edge="end">
                                <SearchIcon/>
                            </IconButton>
                        </InputAdornment>
                    }
                    sx={{bgcolor: theme => theme.palette.background.paper}}
                />
            </FormControl> */}
            <Link to={location.pathname.includes("superadmin") ? `/superAdmin/login `: `/login`}>
            <Button variant="contained">Go to home</Button>
            </Link>
        </Div>
    );
};

export default Error404;
